import React from 'react';

const nmxTemplateVersion = '<%=nmxTemplateVersion%>';
const basePath = '<%=basePath%>';

export const FaviconComponent = () => (
  <React.Fragment>
    <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${basePath}/template/assets/${nmxTemplateVersion}/images/favicon/apple-touch-icon.png`}
      />
    <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${basePath}/template/assets/${nmxTemplateVersion}/images/favicon/favicon-32x32.png`}
      />
    <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${basePath}/template/assets/${nmxTemplateVersion}/images/favicon/favicon-16x16.png`}
      />
    <link
        rel="manifest"
        href={`${basePath}/template/assets/${nmxTemplateVersion}/images/favicon/site.webmanifest`}
      />
    <link
        rel="mask-icon"
        href={`${basePath}/template/assets/${nmxTemplateVersion}/images/favicon/safari-pinned-tab.svg`}
        color="#00487b"
      />
    <link
        rel="shortcut icon"
        href={`${basePath}/template/assets/${nmxTemplateVersion}/images/favicon/favicon.ico`}
      />
    <meta name="apple-mobile-web-app-title" content="Northwestern Mutual" />
    <meta name="application-name" content="Northwestern Mutual" />
    <meta name="msapplication-TileColor" content="#da532c" />
    <meta
        name="msapplication-config"
        content={`${basePath}/template/assets/${nmxTemplateVersion}/images/favicon/browserconfig.xml`}
      />
    <meta name="theme-color" content="#ffffff"></meta>
  </React.Fragment>
);

FaviconComponent.propTypes = { };

FaviconComponent.defaultProps = { };

export default FaviconComponent;
